import posthog from 'posthog-js'

// Initialize PostHog only when a public key is configured.
if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',

    // Disable automatic tracking
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_heatmaps: false,
    enable_heatmaps: false,
    capture_exceptions: false,

    // Disable surveys and other features
    disable_surveys: true,
    disable_web_experiments: true,

    // Enable replay with form input values visible.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
    },

    // Reduce console output
    // loaded: () => {},
    // debug: false,
    // verbose: false,

    // Cookie settings to reduce warnings
    cross_subdomain_cookie: true,
    persistence: 'memory',

    // Allow PostHog to fetch the project's session recording configuration.
    advanced_disable_flags: false,
    property_blacklist: [
      '$web_vitals',
      '$performance',
      '$pageleave',
      '$rageclick',
    ],

    opt_out_capturing_by_default: false,
  })
}

export { default } from 'posthog-js'
